export default __webpack_public_path__ + "static/media/eco-sub-image-05.5773694a.png";